import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faList } from '@fortawesome/sharp-regular-svg-icons'
import { Badge, Button, Modal } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'

import ErrorsList from './ErrorsList'

type ImportErrorsProps = {
  errors: string[]
  file_name: string
  downloadable: boolean
}

const ImportErrors = ({
  downloadable,
  errors,
  file_name,
}: ImportErrorsProps): React.ReactElement => {
  const [opened, { open, close }] = useDisclosure(false)

  if (errors.length === 0) {
    return (
      <Badge
        styles={{ leftSection: { display: 'flex' } }}
        leftSection={<FontAwesomeIcon icon={faCheckCircle} />}
        color="green"
      >
        {i18n.t('no_processing_label_errors', 'Keine Verarbeitungsfehler')}
      </Badge>
    )
  }

  return (
    <>
      <Modal
        opened={opened}
        size="xl"
        onClose={close}
        title={i18n.t('processing_errors_for_filename', {
          defaultValue: 'Verarbeitungsfehler für {{file_name}}',
          file_name,
        })}
      >
        <ErrorsList errors={errors} />
      </Modal>
      <Button
        leftIcon={<FontAwesomeIcon icon={faList} />}
        onClick={open}
        size="xs"
        compact
        color={downloadable ? 'orange' : 'red'}
      >
        {i18n.t('show_n_errors', {
          defaultValue: '{{count}} Verarbeitungsfehler anzeigen',
          count: errors.length,
        })}
      </Button>
    </>
  )
}

export default ImportErrors
